import { render, staticRenderFns } from "./regionResize.vue?vue&type=template&id=6ac2aa4a&scoped=true&"
import script from "./regionResize.vue?vue&type=script&lang=js&"
export * from "./regionResize.vue?vue&type=script&lang=js&"
import style0 from "./regionResize.vue?vue&type=style&index=0&id=6ac2aa4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2aa4a",
  null
  
)

export default component.exports